export default "__VITE_ASSET__BSuCn_uD__"